import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { RouteCoverageChart } from '../../../components/routes-coverage'

function AngularRouteCoverageChart(props) {
  return <RouteCoverageChart {...props} />
}

export const reactRouteCoverageChart = createNgReactBridgeDirective(
  'reactRouteCoverageChart',
  [],
  AngularRouteCoverageChart,
  [
    'height',
    'initialFilter',
    'timeline',
    'routesBreakdown',
    'mostRecentRoutesBreakdown'
  ]
)
